export var GuestSpeakerStreamState;
(function (GuestSpeakerStreamState) {
    GuestSpeakerStreamState[GuestSpeakerStreamState["NO_INVITE"] = 0] = "NO_INVITE";
    GuestSpeakerStreamState[GuestSpeakerStreamState["INVITE_RECEIVED"] = 1] = "INVITE_RECEIVED";
    GuestSpeakerStreamState[GuestSpeakerStreamState["INVITE_ACCEPTED"] = 2] = "INVITE_ACCEPTED";
    GuestSpeakerStreamState[GuestSpeakerStreamState["READY_TO_STREAM"] = 3] = "READY_TO_STREAM";
    GuestSpeakerStreamState[GuestSpeakerStreamState["STREAMING"] = 4] = "STREAMING";
})(GuestSpeakerStreamState || (GuestSpeakerStreamState = {}));
/**
 *
 */
export function createGuestSpeakerState() {
    return {
        hostTokens: {},
        streamState: GuestSpeakerStreamState.NO_INVITE,
        streamControls: {
            cameraEnabled: true,
            microphoneMuted: false,
        },
    };
}
